export interface ConfirmationLinkSession {
  accessToken: string
  refreshToken: string
}

type ConfirmationLink =
  | { kind: 'session'; session: ConfirmationLinkSession }
  | { kind: 'failed' }
  | { kind: 'none' }

/**
 * Reads what GoTrue appends to the redirect after an email confirmation link:
 * the new session (`type=signup`) or an error such as an expired link.
 */
export function readConfirmationLink(hash: string): ConfirmationLink {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash)
  if (params.get('error') || params.get('error_description')) return { kind: 'failed' }
  const accessToken = params.get('access_token')
  const refreshToken = params.get('refresh_token')
  if (params.get('type') !== 'signup' || !accessToken || !refreshToken) return { kind: 'none' }
  return { kind: 'session', session: { accessToken, refreshToken } }
}
